/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState, useMemo } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { faCalculator, faCheck, faHeadSideVirus, faShare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment-business-days";
import { Button } from "react-bootstrap";
import { Switch, FormControlLabel } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";
import { red } from "@mui/material/colors";
import DataTable from "react-data-table-component";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { direvadosKpiDef, humanDateFormat, queryDateFormat, ticketStatusKpiIcons } from "../../../config/constants";
import { BlurSpinner } from "../../components/BlurSpinner";
import Breadcrumb from "../../components/common/breadcrumb";
import DateRangeComponent from "../../components/DateRange";
import KpiCard from "../../components/kpiCard";
import { ShowSearchBar } from "../../components/SearchBar";
import { useSearchBar } from "../../components/SearchBar/context/SearchBarContext";
import { StyledSelect } from "../../components/StyledSelect";
import { useAuth } from "../../context/AuthContext";
import useFetcher from "../../hooks/useFetcher";
import usePaging from "../../hooks/usePaging";
import modulos from "../../mocks/modulos";
import { fetchCasasCentrales } from "../../services/casaCentralServices";
import { fetchTreeMotivo } from "../../services/motivoServices";
import { fetchRegiones } from "../../services/regionServices";
import { fetchSucursales } from "../../services/sucursalServices";
import { downloadTickets, fetchPiAsignable, fetchPiDerivadores, fetchTicketingCategories, fetchTickets } from "../../services/ticketingServices";
import { retriveRegionSucursalOptions } from "../../utils/retriveRegionSucursalOptions";
import { retriveMotivoSubmotivoOptions } from "./retriebeMotivoSubmotivoOptions";
import { fetchAllSubclientWithTickets } from "../../services/subclientesServices";
import { getFaceIconNameAndColorByRating } from "../TicketDetail/Inbox/Tabs";
import { TagButton } from "../../ui/buttons";

const filtarMotivos = (motivos, type) => {
  const motivosToFilter = ["Administrativo", "Comercial", "Selección", "Soporte"];

  if (type === "pincc") {
    // Mostrar solo los motivos que están en el array por label
    return motivos.filter((motivo) => motivosToFilter.includes(motivo.label));
  }

  if (type === "pininterno") {
    // Mostrar todos los motivos menos los que están en el array por label
    return motivos.filter((motivo) => !motivosToFilter.includes(motivo.label));
  }

  return motivos;
};

const Ticketing = ({ history, location }) => {
  const { currentUser, haveSucursalesAccess } = useAuth();
  const isAdmin = currentUser.haveAdminAccess(modulos.TICKETING);
  const isAudit = currentUser.haveAuditAccess(modulos.TICKETING);
  const { searchBarText } = useSearchBar();
  // eslint-disable-next-line max-len
  const [ticketingCategories, isLoadingTicketingCategories, errTicketingCategories] = useFetcher(fetchTicketingCategories, undefined, "fetchTicketingCategories");
  const [piAsignable, isLoadingPiAsignable] = useFetcher(fetchPiAsignable, undefined, "allfetchPiAsignable");
  const [piDerivadores, isLoadingPiDerivadores] = useFetcher(fetchPiDerivadores, undefined, "allfetchPiDerivadores");
  const [regiones, isLoadingRegiones] = useFetcher(fetchRegiones, undefined, "fetchRegiones");
  const [casasCentrales, isLoadingCasasCentrales] = useFetcher(fetchCasasCentrales, undefined, "fetchCasasCentrales");
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursales, undefined, "fetchSucursales");
  const [motivosConfig, isLoadingMotivos] = useFetcher(fetchTreeMotivo, undefined, "fetchTreeMotivo");
  const pagingController = usePaging(fetchTickets);
  const statusStats = pagingController.statusStats ? pagingController.statusStats : [];
  const timeStats = pagingController.timeStats ? pagingController.timeStats : {};
  const totalStats = statusStats.reduce((total, stat) => total + parseInt(stat.count, 10), 0);
  const totalDerivados = statusStats.reduce((total, stat) => total + parseInt(stat.derivados, 10), 0);
  const totalSinLeer = statusStats.reduce((total, stat) => total + parseInt(stat.noleidos, 10), 0);
  const [alertarSinLeer, setAlertarSinLeer] = useState(true);
  const filterDerivados = pagingController.query.derivados === "1";
  // const filtroTotalPressed = pagingController.query.status === undefined && !filterDerivados;
  // const filtroDerivadoPressed = pagingController.query.status === undefined && filterDerivados;
  const [checkedVencido, setCheckedVencido] = useState(false);
  const [checkedCerrados, setCheckedCerrados] = useState(false);
  const [filtersActivesList, setFiltersActivesList] = useState([]);
  const [activedFilters, setActivedFilters] = useState(0);
  const [filteredMotivos, setFilteredMotivos] = useState(null);

  // trae todos los subclientes que tienen tickets
  const [subclients, isLoadingSubclients] = useFetcher(fetchAllSubclientWithTickets, undefined, "fetchAllSubclientes");

  const downloadCSV = async () => {
    toast.success("Su solicitud de exportacion esta siendo procesada");
    const link = document.createElement("a");
    const csv = await downloadTickets(location.search);
    const url = window.URL.createObjectURL(csv);
    const filename = `Tickets-${moment().format(humanDateFormat)}.csv`;
    link.href = url;
    link.setAttribute("download", filename);
    link.click();
    window.URL.revokeObjectURL(url);
  };

  const RedSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: red[700],
      "&:hover": {
        backgroundColor: alpha(red[700], theme.palette.action.hoverOpacity),
      },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: red[700],
    },
  }));

  useEffect(() => {
    pagingController.setFilterValue({ query: searchBarText });
  }, [searchBarText]);

  if (totalSinLeer > 0 && alertarSinLeer) {
    setAlertarSinLeer(false);
    toast.warning(`Tiene ${totalSinLeer} tickets con novedades`);
  }

  const conditionalCellStyles = [
    {
      when: (row) => !row.lecturas || row.lecturas.length === 0,
      style: {
        fontWeight: "800",
      },
    },
    {
      when: (row) => row.highlightSla1 === true,
      style: {
        color: "red",
      },
    },
  ];

  const helperRegionSucursal = retriveRegionSucursalOptions(
    pagingController.query.region,
    pagingController.query.sucursal,
    regiones,
    sucursales,
    casasCentrales,
    isLoadingRegiones || isLoadingCasasCentrales || isLoadingSucursales,
    pagingController.query.mode !== "my" && haveSucursalesAccess(modulos.TICKETING),
    currentUser.user
  );

  const helperMotivoSubmotivo = retriveMotivoSubmotivoOptions(pagingController.query.motivo, pagingController.query.submotivo, motivosConfig, isLoadingMotivos);

  useEffect(() => {
    if (pagingController && pagingController.query && (pagingController.query.pincc || pagingController.query.pininterno)) {
      setFilteredMotivos(filtarMotivos(helperMotivoSubmotivo.motivosOptions, pagingController.query.pincc ? "pincc" : "pininterno"));
    } else if (helperMotivoSubmotivo.motivosOptions && helperMotivoSubmotivo.motivosOptions.length > 0) {
      setFilteredMotivos(helperMotivoSubmotivo.motivosOptions);
    }
  }, [pagingController.query.pincc, pagingController.query.pininterno, pagingController.data]);

  const categoriesOptions = ticketingCategories.categoria
    ? ticketingCategories.categoria
        .map((categoria) => {
          return { label: categoria.text, value: categoria.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const clientsOptions = subclients
    ? subclients
        .map((cliente) => {
          return { label: cliente, value: cliente };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  let piAsignableFilteres = piAsignable;
  if (helperRegionSucursal.selectedRegion || helperRegionSucursal.selectedSucursal) {
    piAsignableFilteres = piAsignable.filter((pi) => {
      const sucursalesPi = (pi.CasaCentral || []).concat(pi.SucursalesAsignadas || []);
      return (
        (!helperRegionSucursal.selectedRegion || sucursalesPi.map((sucursal) => sucursal.region2).includes(helperRegionSucursal.selectedRegion)) &&
        (!helperRegionSucursal.selectedSucursal || sucursalesPi.map((sucursal) => sucursal.itemId).includes(helperRegionSucursal.selectedSucursal))
      );
    });
  }

  const piAsignableOptions = piAsignableFilteres
    .map((pi) => {
      return { label: `${pi.titulo} ${pi.nombre}`, value: pi.itemId };
    })
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  const piDerivadoresOptions = piDerivadores
    ? piDerivadores
        .map((pi) => {
          return { label: pi.nombreApellido, value: pi.itemId };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const canalOptions = ticketingCategories.canal
    ? ticketingCategories.canal
        .map((canal) => {
          return { label: canal.text, value: canal.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const prioridadOptions = ticketingCategories.prioridad
    ? ticketingCategories.prioridad.map((prior) => {
        return { label: prior.text, value: prior.id };
      })
    : [];

  const handleDatesChange = (values) => {
    pagingController.setFilterValue({ startDate: values.rangeDates.startDate, endDate: values.rangeDates.endDate });
  };

  if (activedFilters < 0) {
    setActivedFilters(0);
  }

  const params = location.search || new URLSearchParams();

  let { activeFilterKeys, suma } = useMemo(() => {
    const contienePublico = /categoria/.test(params);
    const contieneCanal = /canal/.test(params);
    const contieneMotivo = /(?<=\b(motivo=))([\d,]+)/.test(params);
    const contieneSubmotivo = /(?<=\b(submotivo=))([\d,]+)/.test(params);
    const contienePrioridad = /prioridad/.test(params);
    const contieneCliente = /cliente/.test(params);
    const contieneDerivadoPor = /derivadopor/.test(params);
    const contienePincc = /pincc/.test(params);
    const contienePininterno = /pininterno/.test(params);
    const contieneAsignado = /asignado/.test(params);
    const cotieneRegion = /region/.test(params);
    const contieneSucursal = /sucursal/.test(params);

    // Lista para almacenar las keys activas
    activeFilterKeys = [];

    // Contar los valores separados por coma dentro de cada sección
    let publicoValores = 0;
    let canalValores = 0;
    let motivoValores = 0;
    let submotivoValores = 0;
    let prioridadValores = 0;
    let clienteValores = 0;
    let derivadoporValores = 0;
    let pinccValores = 0;
    let pininternoValores = 0;

    if (contienePublico) {
      const publicoMatch = params.match(/categoria=([^&]+)/);
      if (publicoMatch) {
        publicoValores = publicoMatch[1].split("%2C").length;
        activeFilterKeys.push("categoria");
      }
    }

    if (contieneCanal) {
      const canalMatch = params.match(/canal=([^&]+)/);
      if (canalMatch) {
        canalValores = canalMatch[1].split("%2C").length;
        activeFilterKeys.push("canal");
      }
    }

    if (contieneMotivo) {
      const motivoMatch = params.match(/motivo=([^,&]+)/);
      if (motivoMatch) {
        motivoValores = motivoMatch[1].split("%2C").length;
        activeFilterKeys.push("motivo");
      }
    }

    if (contieneSubmotivo) {
      const submotivoMatch = params.match(/submotivo=([^,&]+)/);
      if (submotivoMatch) {
        submotivoValores = submotivoMatch[1].split("%2C").length;
        activeFilterKeys.push("submotivo");
      }
    }

    if (contienePrioridad) {
      const prioridadMatch = params.match(/prioridad=([^&]+)/);
      if (prioridadMatch) {
        prioridadValores = prioridadMatch[1].split("%2C").length;
        activeFilterKeys.push("prioridad");
      }
    }

    if (contieneCliente) {
      const clienteMatches = params.match(/cliente=([^&]+)/g);
      if (clienteMatches) {
        clienteValores += clienteMatches.length;
        activeFilterKeys.push("cliente");
      }
    }

    if (contieneDerivadoPor) {
      const derivadoporMatches = params.match(/derivadopor=([^&]+)/g);
      if (derivadoporMatches) {
        derivadoporValores += derivadoporMatches.length;
        activeFilterKeys.push("derivadopor");
      }
    }

    if (contienePincc) {
      const pinccMatch = params.match(/pincc=([^&]+)/);
      if (pinccMatch) {
        pinccValores = pinccMatch[1].split("%2C").length;
        activeFilterKeys.push("pincc");
      }
    }

    if (contienePininterno) {
      const pininternoMatch = params.match(/pininterno=([^&]+)/);
      if (pininternoMatch) {
        pininternoValores = pininternoMatch[1].split("%2C").length;
        activeFilterKeys.push("pininterno");
      }
    }

    if (contieneAsignado) {
      activeFilterKeys.push("asignado");
    }

    if (cotieneRegion) {
      activeFilterKeys.push("region");
    }

    if (contieneSucursal) {
      activeFilterKeys.push("sucursal");
    }

    suma = publicoValores + canalValores + motivoValores + submotivoValores + prioridadValores + clienteValores + derivadoporValores + pinccValores + pininternoValores;

    return { activeFilterKeys, suma };
  }, [params]);

  useEffect(() => {
    setFiltersActivesList(activeFilterKeys);
    setActivedFilters(suma);
  }, [activeFilterKeys, suma]);

  const handleReactSelectChange = (selected, options) => {
    if ((options.action === "select-option" && options.option === undefined) || (options.action === "clear" && options.removedValues.length === 1)) {
      const newState = { [options.name]: selected ? selected.value : null };
      if (newState.region) {
        newState.sucursal = null;
      }
      pagingController.setFilterValue(newState);
    } else {
      const newState = { [options.name]: selected[0] ? selected.map((item) => item.value).join(",") : null };
      if (newState.region) {
        newState.sucursal = null;
      }
      pagingController.setFilterValue(newState);
    }
  };

  const handleMotivoSelectChange = (selected, options) => {
    // eslint-disable-next-line no-unused-expressions
    if ((options.action === "select-option" && options.option === undefined) || (options.action === "clear" && options.removedValues.length === 1)) {
      const newState = { [options.name]: selected ? selected.value : null };
      if (newState.region) {
        newState.sucursal = null;
      }
      pagingController.setFilterValue(newState);
    } else {
      const newState = { [options.name]: selected[0] ? selected.map((item) => item.value).join(",") : null };
      if (newState.region) {
        newState.sucursal = null;
      }
      pagingController.setFilterValue(newState);
    }
  };

  const handleFilterStatus = (status, newFilterDerivados = filterDerivados) => {
    setCheckedCerrados(false);
    pagingController.setFilterValue({ status, derivados: newFilterDerivados ? "1" : undefined });
  };

  const handleVencidoFilter = (e) => {
    const vencido = e.target.value;
    setCheckedVencido(!checkedVencido);
    if (!checkedVencido) {
      pagingController.setFilterValue({ vencido });
    } else {
      pagingController.setFilterValue({ vencido: null });
    }
  };
  const handleCerradoFilter = (e) => {
    const status = e.target.value;
    setCheckedCerrados(!checkedCerrados);
    if (!checkedCerrados) {
      pagingController.setFilterValue({ status });
    } else {
      pagingController.setFilterValue({ status: null });
    }
  };

  const handleTicketClicked = (row) => {
    history.push({
      pathname: `/ticketing/${row.itemId}/detail/${location.search}`,
      state: { ticket: row, from: location },
    });
  };

  let title = "Tickets del Equipo";
  if (pagingController.query.mode === "my") {
    title = "Mis Tickets";
  } else if (pagingController.query.mode === "creador") {
    title = `Tickets Creados Para ${pagingController.query.creadoParaName || ""}`;
  } else if (pagingController.query.mode === "centralizer") {
    title = `Centralización`;
  }

  return (
    <>
      <Helmet>
        <title>PIN - Sistema de Ticketing</title>
      </Helmet>
      <ShowSearchBar defaultValue={pagingController.query.query} />
      <Breadcrumb title={title} parent="Sistema de Ticketing" backButton={pagingController.query.mode === "creador"} />
      <BlurSpinner
        isLoading={
          // eslint-disable-next-line prettier/prettier
          pagingController.isLoading || isLoadingCasasCentrales || isLoadingRegiones || isLoadingSucursales || isLoadingTicketingCategories
        }
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="region" className="col-form-label pt-0 w-100">
                          Region
                          <StyledSelect
                            id="region"
                            name="region"
                            className="w-100"
                            onChange={handleReactSelectChange}
                            value={
                              helperRegionSucursal.regionesOptions.find((option) => {
                                return option.value === helperRegionSucursal.selectedRegion;
                              }) || null
                            }
                            placeholder="Todo"
                            isClearable
                            isLoading={isLoadingRegiones}
                            isDisabled={isLoadingRegiones || helperRegionSucursal.disableRegionSucursal}
                            options={helperRegionSucursal.regionesOptions}
                          />
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="sucursal" className="col-form-label pt-0 w-100">
                          Sucursal
                          <StyledSelect
                            isMulti
                            id="sucursal"
                            name="sucursal"
                            className="w-100"
                            onChange={handleReactSelectChange}
                            value={
                              helperRegionSucursal.casasAndSucusOptions.filter((option) =>
                                pagingController.query.sucursal ? pagingController.query.sucursal.includes(option.value) : ""
                              ) || null
                            }
                            placeholder="Todo"
                            isClearable
                            isLoading={isLoadingCasasCentrales || isLoadingSucursales}
                            isDisabled={isLoadingCasasCentrales || isLoadingSucursales || helperRegionSucursal.disableRegionSucursal}
                            options={helperRegionSucursal.casasAndSucusOptions}
                          />
                        </label>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="form-group">
                        <label htmlFor="asignado" className="col-form-label pt-0 w-100">
                          Asignado
                          <StyledSelect
                            isMulti
                            id="asignado"
                            name="asignado"
                            className="w-100"
                            onChange={handleReactSelectChange}
                            value={piAsignableOptions.filter((option) => (pagingController.query.asignado ? pagingController.query.asignado.includes(option.value) : ""))}
                            placeholder="Todos"
                            isClearable
                            isLoading={isLoadingPiAsignable}
                            disabled={isLoadingPiAsignable}
                            options={piAsignableOptions}
                          />
                        </label>
                      </div>
                    </div>
                    <div className="d-flex col-sm-3 justify-content-space-around">
                      <Dropdown style={{ display: "flex", alignItems: "center" }}>
                        {activedFilters !== 0 ? (
                          <div
                            style={{
                              backgroundColor: "red",
                              borderRadius: "10px",
                              width: "20px",
                              display: "flex",
                              justifyContent: "center",
                              color: "white",
                              position: "relative",
                              bottom: "20px",
                              left: "105px",
                            }}
                          >
                            {activedFilters}
                          </div>
                        ) : (
                          ""
                        )}
                        <Dropdown.Toggle
                          align="start"
                          // variant="success"
                          id="dropdown-basic"
                          style={{ width: "100px", backgroundColor: "#bf0d3e!important", borderColor: "#bf0d3e!important" }}
                        >
                          Filtros
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          {/* tags buttons */}
                          <div className="col-sm-12 d-flex justify-content-end my-3">
                            <TagButton
                              onClick={() => {
                                if (pagingController.query.pincc) {
                                  pagingController.setFilterValue({ pincc: null });
                                } else {
                                  pagingController.setFilterValue({ pincc: true, pininterno: null });
                                }
                              }}
                              isActive={pagingController.query.pincc}
                            >
                              PIN CC
                            </TagButton>
                            <TagButton
                              onClick={() => {
                                if (pagingController.query.pininterno) {
                                  pagingController.setFilterValue({ pininterno: null });
                                } else {
                                  pagingController.setFilterValue({ pininterno: true, pincc: null });
                                }
                              }}
                              isActive={pagingController.query.pininterno}
                            >
                              PIN Interno
                            </TagButton>
                            {filtersActivesList.length > 0 && (
                              <TagButton
                                onClick={() => {
                                  const filtersToReset = filtersActivesList.reduce((acc, key) => {
                                    acc[key] = null;
                                    return acc;
                                  }, {});

                                  pagingController.setFilterValue(filtersToReset);
                                }}
                              >
                                Borrar Filtros
                              </TagButton>
                            )}
                          </div>
                          <div
                            style={{
                              width: "45rem",
                              maxWidth: "45rem",
                              display: "grid",
                              gridTemplateColumns: "21rem 21rem",
                              justifyItems: "center",
                              gap: "1rem",
                              padding: "1rem",
                            }}
                          >
                            {(isAdmin || isAudit) && (
                              <div className="mx-1 w-100">
                                <div>
                                  <label htmlFor="region" className="col-form-label pt-0 w-100">
                                    Derivado Por
                                    <StyledSelect
                                      isMulti
                                      id="derivadopor"
                                      name="derivadopor"
                                      className="w-100"
                                      onChange={handleReactSelectChange}
                                      value={piDerivadoresOptions.filter((option) =>
                                        pagingController.query.derivadopor ? pagingController.query.derivadopor.includes(option.value) : ""
                                      )}
                                      placeholder="Todos"
                                      isClearable
                                      isLoading={isLoadingPiDerivadores}
                                      disabled={isLoadingPiDerivadores}
                                      options={piDerivadoresOptions}
                                    />
                                  </label>
                                </div>
                              </div>
                            )}
                            <div className="mx-1 w-100">
                              <div>
                                <label htmlFor="categoria" className="col-form-label pt-0 w-100">
                                  Publico
                                  <StyledSelect
                                    isMulti
                                    id="categoria"
                                    name="categoria"
                                    className="w-100"
                                    onChange={handleReactSelectChange}
                                    value={categoriesOptions.filter((option) =>
                                      pagingController.query.categoria ? pagingController.query.categoria.includes(option.value) : ""
                                    )}
                                    placeholder="Todo"
                                    isClearable
                                    isLoading={isLoadingTicketingCategories}
                                    disabled={isLoadingTicketingCategories}
                                    options={categoriesOptions}
                                  />
                                </label>
                              </div>
                            </div>
                            <div className="mx-1 w-100">
                              <div>
                                <label htmlFor="region" className="col-form-label pt-0 w-100">
                                  Cliente
                                  <StyledSelect
                                    isMulti
                                    id="cliente"
                                    name="cliente"
                                    className="w-100"
                                    onChange={handleReactSelectChange}
                                    value={clientsOptions.filter((option) =>
                                      pagingController.query.cliente ? pagingController.query.cliente.includes(option.value) : ""
                                    )}
                                    placeholder="Todo"
                                    isClearable
                                    isLoading={isLoadingSubclients}
                                    isDisabled={isLoadingSubclients}
                                    options={clientsOptions}
                                  />
                                </label>
                              </div>
                            </div>
                            <div className="mx-1 w-100">
                              <div>
                                <label htmlFor="canal" className="col-form-label pt-0 w-100">
                                  Canal
                                  <StyledSelect
                                    isMulti
                                    id="canal"
                                    name="canal"
                                    className="w-100"
                                    onChange={handleReactSelectChange}
                                    value={canalOptions.filter((option) => (pagingController.query.canal ? pagingController.query.canal.includes(option.value) : ""))}
                                    placeholder="Todo"
                                    isClearable
                                    isLoading={isLoadingTicketingCategories}
                                    disabled={isLoadingTicketingCategories}
                                    options={canalOptions}
                                  />
                                </label>
                              </div>
                            </div>
                            <div className="mx-1 w-100">
                              <div>
                                <DateRangeComponent onChange={handleDatesChange} values={pagingController.query} label="Rango de fechas" />
                              </div>
                            </div>
                            <div className="mx-1 w-100">
                              <div>
                                <label htmlFor="categoria" className="col-form-label pt-0 w-100">
                                  Motivo
                                  <StyledSelect
                                    isMulti
                                    id="motivo"
                                    name="motivo"
                                    className="w-100"
                                    onChange={handleMotivoSelectChange}
                                    value={helperMotivoSubmotivo.motivosOptions.filter((option) =>
                                      pagingController.query.motivo ? pagingController.query.motivo.includes(option.value) : ""
                                    )}
                                    placeholder="Todo"
                                    isClearable
                                    isLoading={isLoadingMotivos}
                                    disabled={isLoadingMotivos}
                                    options={!filteredMotivos ? helperMotivoSubmotivo.motivosOptions : filteredMotivos}
                                  />
                                </label>
                              </div>
                            </div>
                            <div className="mx-1 w-100">
                              <div>
                                <label htmlFor="categoria" className="col-form-label pt-0 w-100">
                                  Submotivo
                                  <StyledSelect
                                    isMulti
                                    id="submotivo"
                                    name="submotivo"
                                    className="w-100"
                                    onChange={handleMotivoSelectChange}
                                    value={helperMotivoSubmotivo.submotivosOptions.filter((option) =>
                                      pagingController.query.submotivo ? pagingController.query.submotivo.includes(option.value) : ""
                                    )}
                                    placeholder="Todo"
                                    isClearable
                                    isLoading={isLoadingMotivos}
                                    disabled={isLoadingMotivos}
                                    options={helperMotivoSubmotivo.submotivosOptions}
                                  />
                                </label>
                              </div>
                            </div>
                            <div className="mx-1 w-100">
                              <div>
                                <label htmlFor="prioridad" className="col-form-label pt-0 w-100">
                                  Prioridad
                                  <StyledSelect
                                    isMulti
                                    id="prioridad"
                                    name="prioridad"
                                    className="w-100"
                                    onChange={handleReactSelectChange}
                                    value={prioridadOptions.filter((option) =>
                                      pagingController.query.prioridad ? pagingController.query.prioridad.includes(option.value) : ""
                                    )}
                                    placeholder="Todo"
                                    isClearable
                                    isLoading={isLoadingTicketingCategories}
                                    disabled={isLoadingTicketingCategories}
                                    options={prioridadOptions}
                                  />
                                </label>
                              </div>
                            </div>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                      {pagingController.query.mode === "my" && !isAudit && (
                        <div className="d-flex justify-content-start align-items-center ml-2">
                          <button type="button" className="btn btn-success px-3" onClick={() => history.push("/ticketing/new")}>
                            Nuevo Ticket
                          </button>
                        </div>
                      )}
                      {pagingController.query.mode === "team" && (
                        <button type="button" className="btn btn-link secondary" onClick={() => handleFilterStatus(null, !filterDerivados)}>
                          <span>{filterDerivados ? <FontAwesomeIcon icon={faCalculator} size="2x" /> : <FontAwesomeIcon icon={faShare} size="2x" />}</span>
                          <div>Ver {filterDerivados ? "Todos" : "Derivados"}</div>
                        </button>
                      )}
                    </div>
                  </div>
                  {isLoadingTicketingCategories || errTicketingCategories ? (
                    <></>
                  ) : (
                    // CARDS DE STATUS
                    <>
                      <div className="row">
                        {ticketingCategories.status
                          .reduce((acc, el) => {
                            // Elimina la cat cerrado si el switch esta off
                            if (!checkedCerrados && el.id !== 3) {
                              acc.push(el);
                            }
                            // Elimina la cat resuelto si el switch esta on
                            if (checkedCerrados && el.id !== 5) {
                              acc.push(el);
                            }
                            return acc;
                          }, [])
                          .map((statusDef) => {
                            // eslint-disable-next-line max-len
                            const value = { ...statusStats.find((statusStat) => statusStat.status === statusDef.id) };
                            const reStatusDef = { ...statusDef };
                            if (filterDerivados && value) {
                              value.count = value.derivados;
                              reStatusDef.text = (
                                <>
                                  {reStatusDef.text}&nbsp;
                                  <FontAwesomeIcon icon={direvadosKpiDef.icon} />
                                </>
                              );
                            }
                            value.count = value.count || 0;

                            return (
                              ticketStatusKpiIcons[statusDef.id] && (
                                <div className="col-xl-3 col-sm-6" key={`${reStatusDef.id || ""}-kpi-container`}>
                                  <KpiCard
                                    key={`${reStatusDef.id || ""}-kpi`}
                                    statusDef={reStatusDef}
                                    icon={ticketStatusKpiIcons[statusDef.id]}
                                    value={value}
                                    total={filterDerivados ? totalDerivados : totalStats}
                                    onClick={handleFilterStatus}
                                    selected={parseInt(pagingController.query.status, 10) === statusDef.id}
                                  />
                                </div>
                              )
                            );
                          })}
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="card shadow border">
                            <div className="card-body">
                              <div className="media feather-main">
                                <div className="feather-icon-block">
                                  <FontAwesomeIcon icon={faHeadSideVirus} />
                                </div>
                                <div className="media-body align-self-center">
                                  <p className="mb-1">Tiempo de respuesta</p>
                                  <div className="d-flex align-items-end">
                                    {timeStats && timeStats.respuesta_avg ? (
                                      <>
                                        <h6>{parseFloat(timeStats.respuesta_avg).toFixed(2)}</h6>
                                        <div className="pl-1">días</div>
                                      </>
                                    ) : (
                                      <h6>-</h6>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="card shadow border">
                            <div className="card-body">
                              <div className="media feather-main">
                                <div className="feather-icon-block">
                                  <FontAwesomeIcon icon={faCheck} />
                                </div>
                                <div className="media-body align-self-center">
                                  <p className="mb-1">Tiempo de resolución</p>
                                  <div className="d-flex align-items-end">
                                    {timeStats && timeStats.resolucion_avg ? (
                                      <>
                                        <h6>{parseFloat(timeStats.resolucion_avg).toFixed(2)}</h6>
                                        <div className="pl-1">días</div>
                                      </>
                                    ) : (
                                      <h6>-</h6>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="table-responsive support-table">
                    <DataTable
                      title="Tickets"
                      paginationComponentOptions={{ rowsPerPageText: "Tickets por pagina", rangeSeparatorText: "De", selectAllRowsItemText: "Todos" }}
                      noDataComponent={
                        <div className="p-3">
                          <b>No se encontraron tickets</b>
                        </div>
                      }
                      striped
                      pagination
                      sortServer
                      paginationServer
                      actions={[
                        <FormControlLabel
                          control={<RedSwitch color="warning" checked={checkedVencido} onChange={handleVencidoFilter} />}
                          label="Solo vencidos"
                          value={1}
                          style={{ marginTop: "8px" }}
                          key={1}
                        />,
                        <FormControlLabel
                          control={<RedSwitch color="warning" value={3} checked={checkedCerrados} onChange={handleCerradoFilter} />}
                          label="Mostrar cerrados"
                          style={{ marginTop: "8px" }}
                          key={2}
                        />,
                        pagingController.totalRows > 0 && <Button onClick={(e) => downloadCSV(e.target.value)}>Exportar</Button>,
                      ]}
                      onRowClicked={handleTicketClicked}
                      data={pagingController.data}
                      onSort={pagingController.handleSortsChange}
                      paginationTotalRows={pagingController.totalRows}
                      paginationDefaultPage={parseInt(pagingController.query.page || 1, 10)}
                      onChangeRowsPerPage={pagingController.handleRecordsPerPageChange}
                      paginationPerPage={parseInt(pagingController.query.perpage || 10, 10)}
                      onChangePage={pagingController.handlePageChange}
                      columns={[
                        {
                          name: "N° caso",
                          selector: (row) => `${row.fechaDerivadoStart ? "D" : ""}${row.itemId}`,
                          sortable: true,
                          center: true,
                          id: "itemId",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                          },
                          conditionalCellStyles,
                        },
                        {
                          name: "Creado",
                          selector: (row) => (row.fechaCreacionStart ? moment.utc(row.fechaCreacionStart).format(humanDateFormat) : ""),
                          sortable: true,
                          center: true,
                          id: "fechaCreacion",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                            width: "115px",
                          },
                          width: "115px",
                          minWidth: "115px",
                          conditionalCellStyles,
                        },
                        {
                          name: "Vence",
                          selector: (row) => {
                            const initialDate = row.fechaCreacionStart ? moment(new Date(row.fechaCreacionStart)).format(queryDateFormat) : null;
                            if (row.prioridadCat && row.prioridadCat.text === "Alta") {
                              return row.grupoSla === 2
                                ? moment(initialDate).businessAdd(1).format(humanDateFormat)
                                : moment(initialDate).businessAdd(5).format(humanDateFormat);
                            }
                            if (row.prioridadCat && row.prioridadCat.text === "Media") {
                              return row.grupoSla === 2
                                ? moment(initialDate).businessAdd(2).format(humanDateFormat)
                                : moment(initialDate).businessAdd(7).format(humanDateFormat);
                            }
                            if (row.prioridadCat && row.prioridadCat.text === "Baja") {
                              return row.grupoSla === 2
                                ? moment(initialDate).businessAdd(3).format(humanDateFormat)
                                : moment(initialDate).businessAdd(10).format(humanDateFormat);
                            }
                            return "-";
                          },
                          sortable: true,
                          center: true,
                          wrap: true,
                          id: "vencimiento",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                            width: "115px",
                          },
                          minWidth: "115px",
                          conditionalCellStyles,
                        },
                        {
                          name: "Actualización",
                          selector: (row) => (row.updatedAt ? moment.utc(row.updatedAt).format(humanDateFormat) : ""),
                          sortable: true,
                          center: true,
                          id: "updatedAt",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                            width: "115px",
                          },
                          minWidth: "115px",
                          conditionalCellStyles,
                          width: "110px",
                        },
                        {
                          name: "Creado para",
                          selector: (row) =>
                            row.CreadoPara ? row.CreadoPara.nombreApellido || row.CreadoPara.razonSocial || `${row.CreadoPara.nombre} ${row.CreadoPara.apellido}` : "",
                          sortable: true,
                          center: true,
                          id: "creadoPara",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                          },
                          conditionalCellStyles,
                        },
                        {
                          name: "Asignado a",
                          selector: (row) => (row.PersonalInternoAsignado ? row.PersonalInternoAsignado.nombreApellido : ""),
                          sortable: true,
                          center: true,
                          wrap: true,
                          id: "personalInternoAsignado",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                            minWidth: "155px",
                          },
                          conditionalCellStyles,
                        },
                        {
                          name: "Sucursal",
                          selector: (row) => {
                            if (row.SucursaldepartamentoAsignadoCasaCentral) {
                              return row.SucursaldepartamentoAsignadoCasaCentral.title;
                            }
                            if (row.SucursaldepartamentoAsignadoSucursales) {
                              return row.SucursaldepartamentoAsignadoSucursales.titulo;
                            }
                            return "";
                          },
                          sortable: true,
                          center: true,
                          wrap: true,
                          id: "sucursaldepartamentoAsignado",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                          },
                          conditionalCellStyles,
                        },
                        {
                          name: "Estado",
                          selector: ({ status, statusCat, vencido }) =>
                            status ? (
                              <div className="text-center">
                                <span
                                  className="badge"
                                  style={{
                                    fontSize: "unset",
                                    background: `#${statusCat.color}`,
                                  }}
                                >
                                  {statusCat.text}
                                  {vencido === 1 ? (
                                    <>
                                      <br />
                                      (Vencido)
                                    </>
                                  ) : null}
                                </span>
                              </div>
                            ) : (
                              <></>
                            ),
                          sortable: true,
                          center: true,
                          id: "status",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                          },
                          conditionalCellStyles,
                        },
                        {
                          name: "Valoración",
                          selector: (row) => {
                            const { iconName, iconColor } = getFaceIconNameAndColorByRating(row.valoracion !== null ? row.valoracion : null);
                            return row.valoracion !== null ? (
                              <div>
                                <FontAwesomeIcon color={iconColor} size="2x" icon={iconName} />
                              </div>
                            ) : (
                              "-"
                            );
                          },
                          // sortable: true,
                          center: true,
                          id: "status",
                          style: {
                            cursor: "pointer",
                            textAlign: "center",
                          },
                          width: "110px",
                          padding: "0px",
                          conditionalCellStyles,
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </BlurSpinner>
    </>
  );
};

export default withRouter(Ticketing);
